<template>
  <transition name="toast-slide">
    <div v-if="visible" class="toast" :class="`toast--${type}`">
      <i :class="icon"></i>
      <div class="toast-content">
        <strong>{{ title }}</strong>
        <p>{{ message }}</p>
      </div>
      <button class="toast-close" @click="close">
        <i class="bi bi-x"></i>
      </button>
    </div>
  </transition>
</template>

<script>
const TYPE_CONFIG = {
  success: {
    title: "Succès",
    icon: "bi bi-check-circle",
  },
  error: {
    title: "Erreur",
    icon: "bi bi-x-circle",
  },
  warning: {
    title: "Attention",
    icon: "bi bi-exclamation-triangle",
  },
  info: {
    title: "Information",
    icon: "bi bi-info-circle",
  },
  primary: {
    title: "Notification",
    icon: "bi bi-bell",
  },
};

export default {
  name: "VueToast",
  data() {
    return {
      visible: false,
      message: "",
      type: "info",
      timeoutId: null,
    };
  },
  computed: {
    title() {
      return (TYPE_CONFIG[this.type] && TYPE_CONFIG[this.type].title) || "Info";
    },
    icon() {
      return (
        (TYPE_CONFIG[this.type] && TYPE_CONFIG[this.type].icon) ||
        "bi bi-info-circle"
      );
    },
  },
  methods: {
    showToast(message, type = "info", duration = 3500) {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.message = message;
      this.type = type;
      this.visible = true;
      this.timeoutId = setTimeout(() => {
        this.close();
      }, duration);
    },
    close() {
      this.visible = false;
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }
    },
  },
  beforeDestroy() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  },
};
</script>

<style scoped>
.toast {
  position: fixed;
  top: 2rem;
  right: 2rem;
  display: flex;
  gap: 0.9rem;
  align-items: flex-start;
  padding: 1rem 1.2rem;
  border-radius: 16px;
  color: #0f172a;
  background: #ffffff;
  box-shadow: 0 20px 40px rgba(15, 23, 42, 0.12);
  min-width: 280px;
  max-width: min(360px, calc(100% - 2rem));
  z-index: 9998;
}

.toast i {
  font-size: 1.5rem;
}

.toast-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.toast-content strong {
  font-size: 1rem;
  font-weight: 700;
}

.toast-content p {
  margin: 0;
  color: #475569;
  line-height: 1.4;
}

.toast-close {
  background: transparent;
  border: none;
  color: inherit;
  cursor: pointer;
  padding: 0.2rem;
  font-size: 1.1rem;
  line-height: 1;
}

.toast--success {
  border-left: 6px solid #22c55e;
}

.toast--error {
  border-left: 6px solid #ef4444;
}

.toast--warning {
  border-left: 6px solid #f59e0b;
}

.toast--info {
  border-left: 6px solid #0ea5e9;
}

.toast--primary {
  border-left: 6px solid #6366f1;
}

.toast-slide-enter-active,
.toast-slide-leave-active {
  transition: all 0.25s ease;
}

.toast-slide-enter,
.toast-slide-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

@media (max-width: 480px) {
  .toast {
    right: 1rem;
    left: 1rem;
    top: auto;
    bottom: 1.5rem;
    max-width: calc(100% - 2rem);
  }
}
</style>

